module.exports = __webpack_public_path__ + "static/media/social.6e5d3a18.jpg";